export const messages = {
  en: {
    payResult: {
      cart: 'Shopping Cart',
      confirmOrder: 'Confirm Order',
      payment: 'Payment',
      paySuccess: 'Payment Success',
      orderCanceled: 'Order Canceled',
      payResult: 'Payment Result',
      paySuccessMsg: 'You have successfully paid! Please wait for the platform to ship or contact the platform.',
      orderCanceledMsg: 'Your order has been canceled! If you have any questions, please contact the platform.',
      receiverInfo: 'Receiver Information',
      goodsInfo: 'Product Information',
      goods: 'Product',
      price: 'Price',
      quantity: 'Quantity',
      subtotal: 'Subtotal',
      settlementInfo: 'Settlement Information',
      goodsCount: 'items',
      total: 'Total',
      freight: 'Freight',
      invalidOrder: 'Invalid order number, please use correctly',
      inputCorrectNumber: 'Please enter the correct number'
    }
  },
  zh: {
    payResult: {
      cart: '购物车',
      confirmOrder: '确认订单',
      payment: '付款',
      paySuccess: '支付成功',
      orderCanceled: '订单取消',
      payResult: '支付结果',
      paySuccessMsg: '您已经支付成功！请等待平台发货或着联系平台。',
      orderCanceledMsg: '您的订单已经取消！如有疑问请联系平台。',
      receiverInfo: '收货人信息',
      goodsInfo: '商品信息',
      goods: '商品',
      price: '单价',
      quantity: '数量',
      subtotal: '小计',
      settlementInfo: '结算信息',
      goodsCount: '件商品',
      total: '总计',
      freight: '运费',
      invalidOrder: '订单号不正确，请正确使用',
      inputCorrectNumber: '请输入正确的数字'
    }
  }
}